var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 5",
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,28H17a3,3,0,0,0,3-3V24a1,1,0,0,0-2,0v1a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V7A1,1,0,0,1,7,6H17a1,1,0,0,1,1,1V8a1,1,0,0,0,2,0V7a3,3,0,0,0-3-3H7A3,3,0,0,0,4,7V25A3,3,0,0,0,7,28Z",
    fill: "#000000",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.29,11.05a1,1,0,0,0-1.41,1.41L25.41,15H11a1,1,0,0,0,0,2H25.41l-2.53,2.54a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l2.83-2.83a3,3,0,0,0,0-4.24Z",
    fill: "#000000",
    className: "color000 svgShape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouticon);
export default __webpack_public_path__ + "static/media/logouticon.89ab105f1eb35e997a56f741134c0391.svg";
export { ForwardRef as ReactComponent };